import {
  onboardingUrl,
  accountUrl,
  getStarterUrl,
  buildYourGrowthPlanUrl,
} from './urls';

function getUrls(pages: any) {
  const urls = [];
  for (const page in pages) {
    if (pages[page].url) urls.push(pages[page].url);
    else {
      for (const objectPage in pages[page]) {
        urls.push(pages[page][objectPage].url);
      }
    }
  }
  return urls;
}

export let pathname = {
  preLogin: {
    signup: { url: '/signup' },
    login: { url: '/login' },
    forgotPw: { url: '/forgot-password' },
    resetPw: { url: '/reset-password' },
    changePw: { url: '/change-password' },
    calculator: { url: '/8fig-calculator' },
    shopifyAppInstall: {
      url: '/shopify-app',
    },
    loadingPage: {
      url: '/loading',
    },
    getStarted: {
      platform: { url: getStarterUrl + 'platform' },
      salesRevenue: { url: getStarterUrl + 'revenue' },
      accountCreation: { url: getStarterUrl + 'signup' },
      verification: { url: getStarterUrl + 'verification' },
    },
  },
  BuildYourGrowthPlanUrl: {
    welcome: { url: buildYourGrowthPlanUrl + '8figWorld' },
  },
  dashboard: { url: '/' },
  lines: { url: '/lines', label: 'Line Lab' },
  remittance: { url: '/remittance', label: 'Remittance Schedule' },
  plans: { url: '/plans' },
  account: {
    main: { url: accountUrl },
    changePw: { url: accountUrl + '/change-password' },
    editCompany: { url: accountUrl + '/business' },
    editUserName: { url: accountUrl + '/name' },
    bankOAuth: { url: accountUrl + '/bank-oauth' },
  },
  amazonRedirect: { url: '/amazon-seller-redirect' },
  wiseRedirect: { url: '/wise-redirect' },
  submitApplication: { url: '/submit-application' },
  shopify: {
    authRedirect: {
      url: '/shopify-auth-redirect',
    },
  },
  connectAccounts: {
    url: '/connect-accounts',
  },
  onboarding: {
    main: {
      eightFigExplanation: {
        url: onboardingUrl + 'company-explanation',
        stepInStepper: null,
        hideProgressBar: true,
        is8Data: true,
      },
      sellerId: {
        url: onboardingUrl + 'seller-id',
        stepInStepper: null,
        is8Data: true,
      },
      product: {
        url: onboardingUrl + 'product',
        stepInStepper: null,
        is8Data: true,
      },
      productName: {
        url: onboardingUrl + 'product-name',
        stepInStepper: null,
        is8Data: true,
      },
      productNumShipments: {
        url: onboardingUrl + 'product-number-of-shipments',
        stepInStepper: null,
        is8Data: true,
      },
      productNextBatch: {
        url: onboardingUrl + 'product-next-batch',
        stepInStepper: null,
        is8Data: true,
      },
      productPrice: {
        url: onboardingUrl + 'product-price',
        stepInStepper: null,
        is8Data: true,
      },
      lineExplained: {
        url: onboardingUrl + 'line-explained',
        stepInStepper: null,
        is8Data: true,
      },
      createFirstLine: {
        url: onboardingUrl + 'create-first-line',
        stepInStepper: null,
        is8Data: true,
      },
      mobileReviewLines: {
        url: onboardingUrl + 'review-lines',
        stepInStepper: null,
        mobile: true,
        is8Data: true,
      },
      mobileSubmitApp: {
        url: onboardingUrl + 'apply-for-funding',
        stepInStepper: null,
        mobile: true,
        is8Data: true,
      },
    },
    extras: {
      storeUrl: {
        url: onboardingUrl + 'store-url',
        stepInStepper: null,
        is8Data: true,
      },
      companyName: {
        url: onboardingUrl + 'company-name',
        stepInStepper: null,
      },
      productUrl: {
        url: onboardingUrl + 'product-url',
        stepInStepper: null,
      },
    },
  },
};

export const mainOnboardingUrls = getUrls(pathname.onboarding.main);
export const extraOnboardingUrls = getUrls(pathname.onboarding.extras);
export const onboardingUrls = [...mainOnboardingUrls, ...extraOnboardingUrls];
export const preLoginUrls = getUrls(pathname.preLogin);
export const newDesignPathnames = [pathname.account.main.url];
export const allowedDirectUrls = [
  pathname.lines.url,
  pathname.preLogin.loadingPage.url,
];

export const getPathnameIndexInPercent = (basePath) => {
  let counter = 1;

  for (const path in basePath) {
    if (basePath[path].url === window.location.pathname)
      return (counter / Object.keys(basePath).length) * 100;
    counter++;
  }

  return 0;
};
